










































import HeadingButtons from "@/components/HeadingButtons.vue";
import KeyName from "@/components/KeyName.vue";
import { bytesToSize } from "@/utils/conversion";
import { LogsPerServer } from "@/types/debug-mode";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  components: {
    HeadingButtons,
    KeyName,
  },
})
export default class RecentRequestsView extends Vue {
  created() {
    if (this.logsPerServer === null) {
      this.$store.dispatch("debugMode/fetchLogs").then(() => {
        this.currentServerID = Object.keys(this.logsPerServer)[0];
        this.scrollToBottom();
      });
    } else {
      this.currentServerID = Object.keys(this.logsPerServer)[0];
      this.scrollToBottom();
    }
  }

  @State(state => state.debugMode.logs) logsPerServer!: LogsPerServer;

  currentServerID = "";

  bytesToSize(bytes: number) {
    return bytesToSize(bytes);
  }

  scrollToBottom() {
    // make sure element has been inserted into the DOM
    this.$nextTick(() => {
      const logs = document.getElementById("logs-card");
      if (logs !== null) {
        logs.scrollTop = logs.scrollHeight;
      }
    });
  }

  setServer(serverID: string): void {
    this.$ga.toggle("Recent Requests tab: server");
    this.currentServerID = serverID;
    this.scrollToBottom();
  }
}
